import Vue from 'vue';
import Vuetify, { VSnackbar } from 'vuetify/lib';
import VuetifyToast from './toast/index'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify, {
    iconfont: 'md',
    components: {
      VSnackbar
    }
  })

Vue.use(VuetifyToast)

export default new Vuetify({
});
